/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState } from "react";
import ReactGA from "react-ga4";
import { Button, Col, Form, Input, Row, Space, Modal } from "antd";
import { saveArtifiDetails, updateUserIdInArtifi } from "api/services/product.api";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useAppSelector } from "hooks/reduxHooks";
import { CustomProductDetails, Product } from "interfaces/ClientInterface/IProduct";
import { LoadingOutlined } from "@ant-design/icons";
import { notificationController } from "components/Common/Notification/Notification";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "routes/Routes.Constant";
import { useSearchParams } from "react-router-dom";
import Heading from "components/Common/Heading/Heading";
import "./SaveConfiguration.scss";
import { useDispatch } from "react-redux";
import { setUuid } from "store/slices/uuid.slice";

const SaveConfiguration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const guid = searchParams.get("guid");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const product: CustomProductDetails = useAppSelector(
    (state: any) => state.product.customProductDetails
  )!;
  const uId = useAppSelector((state: any) => state?.UuidSlice?.initialState)!;
  const artifi = useAppSelector((state: any) => state?.productCustomization?.artifConfigurations)!;

  const selectedProductRedux: Product = useAppSelector(
    (state: any) => state.product.selectedProduct
  )!;
  const userDetails = useAppSelector((state: any) => state.user.user)!;
  const antIcon = <LoadingOutlined className="spinner" style={{ color: "blue" }} spin />;
  // const isRawlingUpdate = Boolean(localStorage.getItem("isRawlingUpdate"));

  const showCancelConfirmation = () => {
    Modal.confirm({
      title: (
        <div className="confirmation-modal-title">
          <span className="icon-span">
            <ExclamationCircleOutlined />
          </span>
          <span>Are you sure you want to cancel?</span>
        </div>
      ),
      icon: null,
      onOk() {
        navigate(ROUTES_PATH.HOMEPAGE);
      },
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        className: "ok-button",
      },
      cancelButtonProps: {
        className: "cancel-button",
      },
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleFinish = (values: any) => {
    if (product || guid) {
      const reqBody: any = {};

      const selectedProductName = localStorage.getItem("selectedProduct");
      if (product) {
        reqBody.productId = selectedProductRedux?.PublishProductId;
        reqBody.productName = selectedProductName; //product name if artifi or selected name
        reqBody.sku = selectedProductRedux?.SKU;
        reqBody.configurationName = values?.configurationName;
        reqBody.groupName = values?.groupName;
        reqBody.userId = userDetails?.id;
        reqBody.designId = product.designId; //designId will be from artifi
        reqBody.productCustomizationJson = JSON.stringify(product); //also save this in redux
        reqBody.CreatedBy = userDetails?.id;
        reqBody.DesignType = "Artifi";
        reqBody.MethodType = "Insert";
      }

      if (guid) {
        reqBody.productId = 0;
        reqBody.productName = selectedProductName;
        reqBody.sku = localStorage.getItem("SKU");
        reqBody.configurationName = values?.configurationName;
        reqBody.groupName = values?.groupName;
        reqBody.userId = userDetails?.id;
        reqBody.designId = "";
        // reqBody.designId = isRawlingUpdate ? guid : "";
        reqBody.guid = guid;
        reqBody.productCustomizationJson = "";
        reqBody.CreatedBy = userDetails?.id;
        reqBody.DesignType = "Rawlings";
        reqBody.MethodType = "Insert";
        // reqBody.MethodType = !isRawlingUpdate ? "Insert" : "Update";
      }

      ReactGA.event({
        category: "save_design_configurations",
        action: "save design configurations button clicked",
        label: "save design configurations button clicked"
      });

      setIsLoading(true);
      saveArtifiDetails(reqBody)
        .then(async () => {
          localStorage.removeItem("selectedProduct");
          setIsLoading(false);
          if (
            reqBody?.DesignType === "Artifi" &&
            localStorage.getItem("isLoggedInUser") === "false"
          ) {
            const url =
              `${artifi?.Custom1}api/3/User/UpdateUserId?websiteId=${artifi?.WebsiteCode}` +
              `&webApiClientKey=${artifi?.WebApiclientKey}&newUserId=${userDetails?.id}` +
              `&oldUserId=${uId}&isGuest=true`;
            updateUserIdInArtifi(url)
              .then((result: any) => {
                if (result && result?.data) {
                  dispatch(setUuid("" as any));
                }
              })
              .catch((error) => {
                throw error;
              });
          }
          notificationController.success({
            message: "Design saved Successfully",
          });
          navigate("/");
        })
        .catch((err) => {
          setIsLoading(false);
          notificationController.error({
            message: "Something went wrong.",
          });
          throw err;
        });
    }
  };

  return (
    <div className="page-content-wrapper p-30">
      <Row gutter={15} className="global-form-container">
        <Col span={12} xs={24} md={12} xxl={12} lg={12}>
          <Heading titleText="Save Configuration" titleClass="global-form-heading" />
          <div className="form-wrapper">
            <Form
              layout="vertical"
              name="login"
              initialValues={{ configurationName: product?.designName, groupName: "" }}
              autoComplete="off"
              onFinish={handleFinish}
            >
              <Form.Item
                label={
                  <span className="wrapper">
                    Configuration Name <span className="text-danger">*</span>
                  </span>
                }
                name="configurationName"
                rules={[
                  {
                    required: true,
                    message: "This field cannot be left blank.",
                  },
                  {
                    max: 100,
                    message: "The configuration name must be within 100 characters.",
                  },
                ]}
                className="input-label"
              >
                <Input className="form-input" />
              </Form.Item>
              <Form.Item
                label="Add to Group (optional)"
                name="groupName"
                rules={[
                  {
                    max: 100,
                    message: "The group name must be 100 characters.",
                  },
                ]}
                className="input-label"
              >
                <Input className="form-input" />
              </Form.Item>

              <Form.Item className="global-form-action">
                <Space size={"middle"}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="save-btn"
                    disabled={isLoading}
                  >
                    Save {isLoading && antIcon}
                  </Button>
                  <Button className="cancel-btn" onClick={showCancelConfirmation}>
                    Cancel
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SaveConfiguration;
